import { GameCase as GameCaseType } from "app/types";

// Used in ProjectPreviewModal for displaying game case images
export const CreatorGameCaseManager = {
  [GameCaseType.GRAY]: "small_gray_case.png",
  [GameCaseType.SOFT_YELLOW]: "small_soft_yellow_case.png",
  [GameCaseType.GREEN]: "small_green_case.png",
  [GameCaseType.CYAN]: "small_cyan_case.png",
  [GameCaseType.BLUE]: "small_blue_case.png",
  [GameCaseType.MILK]: "small_milk_case.png",
  [GameCaseType.PINK]: "small_pink_case.png",
  [GameCaseType.ORANGE]: "small_orange_case.png",
  [GameCaseType.SOFT_PINK]: "small_soft_pink_case.png",
};
